/* eslint-disable */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { getFile } from '@/store/files/actions';
import { registerKampusUser, registerUser } from '@/store/login/actions';
import { getDepartmentList, getPositionList } from '@/store/trajectory/actions';
import { setAvaToCache } from '@/store/user-topics/actions';
import {
  editAboutUser,
  getUser,
  getUserPositions,
  loadAvatarUser,
  overwriteValuesUser,
  updateAvatarUser,
} from '@/store/users/actions';

import { selectLogin as loginSelect } from '@/store/login/selectors';
import { selectTrajectory } from '@/store/trajectory/selectors';
import { selectUsers as userSelect } from '@/store/users/selectors';

import { Alert, Button, Form, Input, Layout, message, Select, Spin } from 'antd';
import AvatarInput from '@/components/AvatarInput/AvatarInput';
import LogoCompany from '@/components/LogoCompany/LogoCompany';
import { CloseOutlined, InfoCircleFilled } from '@ant-design/icons';

import department from '../Collegues/views/department';

import { getValidateEmail } from '@shared/utils/validate-utils';

import Utils from '@/Utils';
import { createSelector } from '@reduxjs/toolkit';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';
import PropTypes from 'prop-types';

import css from './Login.module.scss';

const { TextArea } = Input;
const { Content } = Layout;

const SPP_ID = 5652;
const PATH_ABOUT_PAGE = '/personal-data/registration-page-data-about';
class RegistrationPageDataAbout extends Component {
  static propTypes = {
    changeRenderPage: PropTypes.func,
    currentUser: PropTypes.object,
    editAboutUser: PropTypes.func,
    errorNum: PropTypes.number,
    getFile: PropTypes.func,
    getUser: PropTypes.func,
    imageBackgroundLogin: PropTypes.any,
    imageLogo: PropTypes.any,
    loadAvatarUser: PropTypes.func,
    login: PropTypes.func,
    loginError: PropTypes.bool,
    overwriteValuesUser: PropTypes.func,
    registerUser: PropTypes.func,
    updateAvatarUser: PropTypes.func,
    updateLoginEmpty: PropTypes.func,
    oauthUserData: PropTypes.object,
    edit: PropTypes.bool,
    onClose: PropTypes.func,
    setAvaToCache: PropTypes.func,
    getUserPositions: PropTypes.func,
    registerKampusUser: PropTypes.func,
    isNotFixed: PropTypes.bool,
    editProfile: PropTypes.bool, // проверка на вызов с моего профиля
  };

  constructor(props) {
    super(props);

    this.state = {
      currentUser: props.currentUser,
      about: props.currentUser?.about || '',
      localPhotoUuid: null,
      imageSrc: null,
      department: props.currentUser?.department
        ? {
            key: props.currentUser.department.id,
            name: props.currentUser.department.name,
          }
        : undefined,
      career: props.currentUser?.position
        ? {
            key: props.currentUser.position.id,
            name: props.currentUser.position.name,
          }
        : undefined,
      function: props.currentUser?.function
        ? {
            key: props.currentUser.function.id,
            name: props.currentUser.function.name,
          }
        : undefined,
      careerTxt: '',
      departmentTxt: '',
      functionTxt: '',
      phoneTxt: '',
      companyTxt: '',
      profileEdit: props.profileEdit,
      isKampus: document.location.hostname === 'td.kampus.team',
      errors: {},
      isRegister: false,
      email: '',
      departmentId: props.currentUser.department?.id,
      functionId: props.currentUser.function?.id,
      positionId: props.currentUser.position?.id,
    };

    this.onlyMobileProvider = Utils.isMobileProvider(props.currentUser) && !Utils.isInternalProvider(props.currentUser);
  }

  componentDidMount() {
    if (document.location.pathname === '/personal-data/registration-page-data-about') {
      this.setState({ isRegister: true });
    }

    const profileEdit = !!this.props.currentUser?.domainCompany?.profileEdit;

    this.setState({ profileEdit });

    if (this.props.currentUser && !this.props.profileEdit) {
      this.setState({
        careerTxt: this.props.currentUser.position?.name || '',
        departmentTxt: this.props.currentUser.department?.name || '',
        functionTxt: this.props.currentUser.function?.name || '',
      });
    }

    if (this.props.oauthUserData?.photo) {
      this.getOauthAvatar();
    }

    if (this.props.currentUser?.domainCompany?.hasUserPosition && (this.props.profileEdit || profileEdit)) {
      this.props.getPositionList();
    }

    if (this.props.currentUser?.domainCompany?.hasUserDepartment && (this.props.profileEdit || profileEdit)) {
      this.props.getDepartmentList();
    }

    if (this.props.currentUser?.domainCompany?.hasUserFunction && (this.props.profileEdit || profileEdit)) {
      this.props.getUserPositions({ size: 1000 });
    }

    const currentFunction = this.props.currentUser?.function?.name || '';
    const functionIndex = this.props.functionsList?.findIndex(value => value === currentFunction);

    const functionKey = isNumber(functionIndex) && functionIndex !== -1 ? functionIndex + 1 : null;

    if (functionKey !== null && functionKey >= 0) {
      this.setState({ function: { key: functionKey, label: currentFunction } });
    }

    if (this.state.isKampus && this.props.currentUser) {
      this.setState({
        careerTxt: this.props.currentUser.position?.name || '',
        companyTxt: this.props.currentUser.subCompany?.name || '',
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isKampus !== this.state.isKampus) {
      if (this.state.isKampus && this.props.currentUser) {
        this.setState({
          careerTxt: this.props.currentUser.position?.name || '',
          companyTxt: this.props.currentUser.subCompany?.name || '',
        });
      }
    }

    if (prevProps.functionsList.length !== this.props.functionsList.length) {
      const currentFunction = this.props.currentUser?.function?.name || '';
      const functionIndex = this.props.functionsList?.findIndex(item => item.value === currentFunction);

      const functionKey = isNumber(functionIndex) && functionIndex !== -1 ? functionIndex + 1 : null;

      if (functionKey !== null && functionKey >= 0) {
        this.setState({ function: { key: functionKey, label: currentFunction } });
      }
    }
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleChangeSelect = (value, name) => {
    switch (name) {
      case 'career':
        const findCareer = this.props.positionsList?.find(item => item.id === value);
        return this.setState(prevState => ({
          errors: { ...prevState.errors, [name]: '' },
          positionId: value,
          career: findCareer ? { id: findCareer?.id, name: findCareer?.label } : undefined,
        }));

      case 'department':
        const findDepartment = this.props.departmentsList?.find(item => item.id === value);
        return this.setState(prevState => ({
          errors: { ...prevState.errors, [name]: '' },
          departmentId: value,
          department: findDepartment ? { id: findDepartment?.id, name: findDepartment?.label } : undefined,
        }));

      case 'function':
        const findFunction = this.props.functionsList?.find(item => item.id === value);
        return this.setState(prevState => ({
          errors: { ...prevState.errors, [name]: '' },
          functionId: value,
          function: findFunction ? { id: findFunction?.id, name: findFunction?.label } : undefined,
        }));

      default:
        break;
    }
  };

  validateRequired = () => {
    let valid = true;

    if (!this.state.isKampus) {
      if (!this.state.career) {
        this.setState(prevState => ({ errors: { ...prevState.errors, career: this.props.t('requiredText') } }));
        valid = false;
      }

      if (!this.state.department) {
        this.setState(prevState => ({ errors: { ...prevState.errors, department: this.props.t('requiredText') } }));

        valid = false;
      }

      if (!this.state.function) {
        this.setState(prevState => ({ errors: { ...prevState.errors, function: this.props.t('requiredText') } }));
        valid = false;
      }
    }

    if (this.state.isKampus) {
      const onlyNumbersString = this.state.phoneTxt.replace(/\D/g, '');
      const minPhoneLength = 11;

      const cleanCareerTxt = this.state.careerTxt.trim();
      const cleanCompanyTxt = this.state.companyTxt.trim();

      if (onlyNumbersString.length < minPhoneLength && document.location.pathname === PATH_ABOUT_PAGE) {
        this.setState(prevState => ({ errors: { ...prevState.errors, phoneTxt: this.props.t('requiredText') } }));
        valid = false;
      }

      if (!cleanCareerTxt && document.location.pathname === PATH_ABOUT_PAGE) {
        this.setState(prevState => ({ errors: { ...prevState.errors, careerTxt: this.props.t('requiredText') } }));
        valid = false;
      }

      if (!cleanCompanyTxt && document.location.pathname === PATH_ABOUT_PAGE) {
        this.setState(prevState => ({ errors: { ...prevState.errors, companyTxt: this.props.t('requiredText') } }));
        valid = false;
      }
    }

    return valid;
  };

  isLoginOnlyNumbsAndPlus = /^\+?\d{10,}$/.test(this.props.currentUser?.login);
  isLoginOnlyNumbs = /^\d+$/.test(this.props.currentUser?.login);

  handleChangeRenderPage = () => {
    const { currentUser } = this.props;
    localStorage.setItem('welcome', 'true');

    const oldValue = currentUser;

    const localPhotoUuid = this.state.localPhotoUuid ? this.state.localPhotoUuid : currentUser.localPhotoUuid;
    const about = this.state.about;
    const companyId = currentUser?.domainCompany?.id;
    const newEmail =
      currentUser?.login?.includes('@') || !this.isLoginOnlyNumbsAndPlus
        ? currentUser?.email
        : this.state.email || null;
    const correctPhone =
      Utils.isMobileProvider(currentUser) &&
      !currentUser?.login?.includes('@') &&
      this.isLoginOnlyNumbs &&
      !currentUser?.phone
        ? currentUser?.login
        : currentUser?.phone;

    const newValue = {
      localPhotoUuid,
      about,
      id: currentUser.id,
      firstName: currentUser.firstName,
      secondName: currentUser.secondName,
      departmentId: this.state.departmentId || undefined,
      functionId: this.state.functionId || undefined,
      positionId: this.state.positionId || undefined,
      managerIds: currentUser?.managers?.map(manager => manager.id) || [],
      managerId: currentUser?.managers?.length && currentUser.managers[0].id,
      email: newEmail,
      phone: correctPhone,
    };

    if (this.state.isRegister) {
      delete oldValue.login;
    }

    if ((SPP_ID === +companyId || this.state.isKampus) && !this.validateRequired()) return;

    //проверка для валидации поля почты
    if (!newEmail || (getValidateEmail(newEmail) && newEmail)) {
      if (this.state.isKampus) {
        const onlyNumbersString =
          this.state.phoneTxt?.length > 0 ? '+' + this.state.phoneTxt.replace(/\D/g, '') : undefined;
        const cleanCareerTxt = this.state.careerTxt.trim();
        const cleanCompanyTxt = this.state.companyTxt.trim();

        const body = {
          phone: onlyNumbersString,
          position: cleanCareerTxt,
          company: cleanCompanyTxt,
          localPhotoUuid,
        };

        this.props.registerKampusUser(body, () => {
          if (this.props.edit && this.props.onClose) {
            this.props.onClose();
          } else {
            this.props.navigate('/planning');
          }
        });
      }

      if (!this.state.isKampus) {
        this.props.overwriteValuesUser(oldValue, newValue, () => {
          if (this.props.edit && this.props.onClose) {
            this.props.onClose();
          } else {
            this.props.navigate('/planning');
          }
        });
      }
    } else {
      message.error(this.props.t('incorrectEmail'));
    }
  };

  getOauthAvatar = () => {
    const { oauthUserData } = this.props;

    this.getFile(oauthUserData.photo);
  };

  getFile = uuid => {
    this.props.getFile(uuid, res => {
      this.setState({
        imageSrc: URL.createObjectURL(res),
        localPhotoUuid: uuid,
      });
    });
  };

  changeInput = event => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState(prevState => ({ errors: { ...prevState.errors, [name]: undefined }, [name]: value }));
  };

  changeInputEmail = event => {
    const name = event.target.name;
    const value = event.target.value;

    if (!getValidateEmail(value) && value.length > 0) {
      this.setState(prevState => ({
        errors: { ...prevState.errors, [name]: this.props.t('incorrectEmail') },
        [name]: value,
      }));
    } else {
      this.setState(prevState => ({ errors: { ...prevState.errors, email: undefined }, [name]: value }));
    }
  };

  filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  render() {
    const { t } = this.props;

    return (
      <Content
        className={classNames({
          [css.LoginContent]: this.props.isNotFixed,
          [css.LoginContentAbsolute]: !this.props.isNotFixed,
          [css['LoginContent-edit']]: this.props.edit,
        })}
      >
        <div
          className={classNames(css['App-card-item'], {
            [css['App-card-item-register']]: this.state.isRegister,
            [css['App-card-item-edit']]: this.props.edit,
            [css['App-card-item__myProfile']]: this.props.editProfile,
          })}
        >
          {this.state.profileEdit ? (
            <>
              {(this.props.loadingDepartments || this.props.loadingCareers || !this.props.currentUser) && (
                <div className={css.loader}>
                  <Spin />
                </div>
              )}
            </>
          ) : null}

          <img className={css.imageBackgroundLogin} src={this.props.imageBackgroundLogin} alt='' />

          <Form layout='vertical' className={css['LoginPage-form']} colon={false}>
            <div
              className={classNames(css['LoginPage-form__contentRegistrationData'], {
                [css['LoginPage-form__contentRegistrationData-edit']]: this.props.editProfile,
              })}
            >
              {this.props.imageLogo && (
                <div className={css['LoginPage-header']}>
                  <div className={css['LoginPage-header__logo']}>
                    <LogoCompany imageLogo={this.props.imageLogo} />
                  </div>
                </div>
              )}
              {!this.state.isKampus && (
                <>
                  <div className={classNames(css['LoginPage-titleHead'], css['LoginPage-titleHead-registration'])}>
                    {t('profile')}
                  </div>
                  <Alert
                    message={t('about')}
                    className={css['LoginPage-titleHead-alert']}
                    showIcon
                    closable
                    icon={<InfoCircleFilled className={css['LoginPage-titleHead-alert-icon']} />}
                  />
                  <div className={classNames(css['avatar'])}>
                    <AvatarInput
                      modificate
                      imageSrc={this.state.imageSrc}
                      user={this.props.currentUser}
                      getFile={this.props.getFile}
                      getPhoto={this.getFile}
                      loadAvatarUser={this.props.loadAvatarUser}
                      formLabel={t('avatar')}
                    />
                  </div>
                  <Form.Item label={t('login')} labelAlign={'left'} className={css['LoginPage-dictionaries-row']}>
                    <Input
                      defaultValue={this.props.currentUser?.login}
                      disabled
                      data-qa='registrationAboutLoginInput'
                    />
                  </Form.Item>

                  {(this.props.currentUser.login?.includes('@') || !this.isLoginOnlyNumbsAndPlus) && (
                    <>
                      {!this.onlyMobileProvider && (
                        <Form.Item label={t('email')} labelAlign={'left'} className={css['LoginPage-dictionaries-row']}>
                          <div data-qa='registrationAboutEmail'>{this.props.currentUser.email}</div>
                        </Form.Item>
                      )}
                      {this.props.currentUser.phone && (
                        <Form.Item label={t('phone')} labelAlign={'left'} className={css['LoginPage-dictionaries-row']}>
                          {this.props.currentUser.phone}
                        </Form.Item>
                      )}
                    </>
                  )}

                  {!this.props.currentUser.login?.includes('@') && this.isLoginOnlyNumbsAndPlus && (
                    <>
                      <Form.Item label={t('phone')} labelAlign={'left'} className={css['LoginPage-dictionaries-row']}>
                        <Input
                          defaultValue={this.props.currentUser?.phone}
                          disabled
                          placeholder={t('phonePlaceholder')}
                        />
                      </Form.Item>
                      {!this.onlyMobileProvider && (
                        <Form.Item
                          label={t('email')}
                          help={this.state.errors.email}
                          labelAlign={'left'}
                          className={classNames(css['LoginPage-dictionaries-row'], {
                            [css.error]: this.state.errors.email,
                          })}
                          validateStatus={this.state.errors.email ? 'error' : ''}
                          hasFeedback
                          initialValue={this.state.email || this.props.currentUser.email}
                        >
                          <Input
                            name='email'
                            defaultValue={this.state.email || this.props.currentUser.email}
                            onChange={this.changeInputEmail}
                            maxLength={40}
                            placeholder={t('mail')}
                            type='tel'
                          />
                        </Form.Item>
                      )}
                    </>
                  )}

                  {this.state.currentUser?.domainCompany?.hasUserPosition && (
                    <>
                      {this.state.profileEdit && this.props.positionsList?.length ? (
                        <Form.Item
                          label={Utils.capitalize(this.state.currentUser.domainCompany.positionSingleNameImenit)}
                          help={this.state.errors.career}
                          validateStatus={this.state.errors.career ? 'error' : ''}
                          className={classNames(css['LoginPage-dictionaries-row'], {
                            [css.error]: this.state.errors.career,
                          })}
                          hasFeedback
                        >
                          <Select
                            allowClear={{ clearIcon: <CloseOutlined /> }}
                            showSearch
                            placeholder={t('put')}
                            notFoundContent={t('noResult')}
                            onChange={value => this.handleChangeSelect(value, 'career')}
                            options={this.props.positionsList?.map(option => ({
                              label: option.label,
                              value: option.id,
                            }))}
                            value={this.state.positionId}
                            className={classNames(css['select'], css['select-full'])}
                            id='registrationAboutPositionSelect'
                            filterOption={this.filterOption}
                          />
                        </Form.Item>
                      ) : (
                        <Form.Item
                          label={Utils.capitalize(this.state.currentUser.domainCompany.positionSingleNameImenit)}
                        >
                          <Input
                            className={classNames(css['LoginPage--select'])}
                            value={this.state.careerTxt}
                            disabled
                          />
                        </Form.Item>
                      )}
                    </>
                  )}
                  {this.state.currentUser?.domainCompany?.hasUserDepartment && (
                    <>
                      {this.state.profileEdit && this.props.departmentsList?.length ? (
                        <Form.Item
                          label={Utils.capitalize(this.state.currentUser.domainCompany.departmentSingleNameImenit)}
                          help={this.state.errors.department}
                          validateStatus={this.state.errors.department ? 'error' : ''}
                          className={classNames(css['LoginPage-dictionaries-row'], {
                            [css.error]: this.state.errors.department,
                          })}
                          hasFeedback
                        >
                          <Select
                            allowClear={{ clearIcon: <CloseOutlined /> }}
                            showSearch
                            placeholder={t('put')}
                            notFoundContent={t('noResult')}
                            onChange={value => this.handleChangeSelect(value, 'department')}
                            value={this.state.departmentId}
                            options={this.props.departmentsList?.map(option => ({
                              label: option.label,
                              value: option.id,
                            }))}
                            className={classNames(css['select'], css['select-full'])}
                            id='registrationAboutDepartmentSelect'
                            filterOption={this.filterOption}
                          />
                        </Form.Item>
                      ) : (
                        <Form.Item
                          label={Utils.capitalize(this.state.currentUser.domainCompany.departmentSingleNameImenit)}
                        >
                          <Input
                            className={classNames(css['LoginPage--select'])}
                            value={this.state.departmentTxt}
                            disabled
                          />
                        </Form.Item>
                      )}
                    </>
                  )}
                  {this.props.currentUser?.domainCompany?.hasUserFunction && (
                    <>
                      {this.state.profileEdit && this.props.functionsList?.length ? (
                        <Form.Item
                          label={Utils.capitalize(this.state.currentUser.domainCompany.functionSingleNameImenit)}
                          help={this.state.errors.function}
                          validateStatus={this.state.errors.function ? 'error' : ''}
                          className={classNames(css['LoginPage-dictionaries-row'], {
                            [css.error]: this.state.errors.function,
                          })}
                          hasFeedback
                        >
                          <Select
                            allowClear={{ clearIcon: <CloseOutlined /> }}
                            showSearch
                            placeholder={t('put')}
                            notFoundContent={t('noResult')}
                            onChange={value => this.handleChangeSelect(value, 'function')}
                            value={this.state.functionId}
                            options={this.props.functionsList?.map(option => ({
                              label: option.label,
                              value: option.id,
                            }))}
                            className={classNames(css['select'], css['select-full'])}
                            id='registrationAboutFunctionSelect'
                            filterOption={this.filterOption}
                          />
                        </Form.Item>
                      ) : (
                        <Form.Item
                          label={Utils.capitalize(this.state.currentUser.domainCompany.functionSingleNameImenit)}
                        >
                          <Input
                            className={classNames(css['LoginPage--select'])}
                            value={this.state.functionTxt}
                            disabled
                          />
                        </Form.Item>
                      )}
                    </>
                  )}
                  {/* о себе */}
                  <Form.Item label={t('aboutYourself1')} className={css['LoginPage-dictionaries-row']}>
                    <TextArea
                      data-qa='registrationAboutAboutInput'
                      name='about'
                      className={classNames(css['LoginPage-form-textAbout'], {
                        [css['LoginPage-form-textAbout-edit']]: this.props.edit,
                      })}
                      rows={2}
                      placeholder={t('aboutYourself2')}
                      onChange={this.changeInput}
                      value={this.state.about}
                      maxLength={1000}
                    />
                  </Form.Item>
                </>
              )}

              {this.state.isKampus && (
                <>
                  <div className={classNames(css['avatar'])}>
                    <AvatarInput
                      modificate
                      imageSrc={this.state.imageSrc}
                      user={this.props.currentUser}
                      getFile={this.props.getFile}
                      getPhoto={this.getFile}
                      loadAvatarUser={this.props.loadAvatarUser}
                    />
                  </div>
                  {!this.props.edit && (
                    <Form.Item
                      label={t('phone')}
                      help={this.state.errors.phoneTxt}
                      validateStatus={this.state.errors.phoneTxt ? 'error' : ''}
                      className={classNames(css['LoginPage-dictionaries-row'], {
                        [css.error]: this.state.errors.phoneTxt,
                      })}
                      hasFeedback
                    >
                      <Input
                        name='phoneTxt'
                        value={this.state.phoneTxt}
                        onChange={this.changeInput}
                        maxLength={25}
                        placeholder={t('placeholderPhone')}
                        type='tel'
                        minLength={11}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    label={t('position')}
                    help={this.state.errors.careerTxt}
                    validateStatus={this.state.errors.careerTxt ? 'error' : ''}
                    className={classNames(css['LoginPage-dictionaries-row'], {
                      [css.error]: this.state.errors.careerTxt,
                    })}
                    hasFeedback
                  >
                    <Input name='careerTxt' value={this.state.careerTxt} onChange={this.changeInput} />
                  </Form.Item>

                  <Form.Item
                    label={t('company')}
                    help={this.state.errors.companyTxt}
                    validateStatus={this.state.errors.companyTxt ? 'error' : ''}
                    className={classNames(css['LoginPage-dictionaries-row'], {
                      [css.error]: this.state.errors.companyTxt,
                    })}
                    hasFeedback
                  >
                    <Input name='companyTxt' value={this.state.companyTxt} onChange={this.changeInput} />
                  </Form.Item>
                </>
              )}

              <div className={css['LoginPage-form-FooterButtonsDesktop']}>
                <Button onClick={this.props.onClose}>{t('cancel')}</Button>
                <Button
                  disabled={this.state?.errors && Object.values(this.state.errors)?.filter(item => item)?.length > 0}
                  type='primary'
                  onClick={this.handleChangeRenderPage}
                  htmlType='submit'
                  data-qa='registrationAboutDoneButton'
                >
                  {t('save')}
                </Button>
              </div>
              <div
                className={classNames(css['LoginPage-form-FooterButtonsMobile'], {
                  [css['LoginPage-form-FooterButtonsMobile-edit']]: this.props.edit,
                })}
              >
                <Button onClick={this.props.onClose}>{t('cancel')}</Button>
                <Button
                  // disabled={this.state?.errors && Object.keys(this.state.errors)?.length === 0}
                  type='primary'
                  onClick={this.handleChangeRenderPage}
                >
                  {t('apply')}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Content>
    );
  }
}
const mapStateToProps = createSelector(
  [loginSelect, userSelect, selectTrajectory],
  (loginState, userState, selectTrajectory) => ({
    errorNum: loginState.errorNum,
    loginError: loginState.error,
    oauthUserData: loginState.oauthUserData,
    currentUser: userState.currentUser,
    departmentsList: selectTrajectory.departmentsList,
    positionsList: selectTrajectory.positionsList,
    loadingDepartments: selectTrajectory.loadingDepartments,
    loadingCareers: selectTrajectory.loadingCareers,
    functionsList:
      userState.positions?.content?.map(el => ({
        id: el.id,
        label: el.name,
        value: el.id,
      })) || [],
  })
);

const mapActionsToProps = {
  registerUser,
  getUser,
  getFile,
  editAboutUser,
  loadAvatarUser,
  updateAvatarUser,
  overwriteValuesUser,
  getDepartmentList,
  getPositionList,
  setAvaToCache,
  getUserPositions,
  registerKampusUser,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withTranslation('registrationData')(RegistrationPageDataAbout));
